'use strict';

require('../../style/index.less');


/*****************
 ** WEBPACK FOOTER
 ** ./components/icon/style/index.tsx
 ** module id = 591
 ** module chunks = 0
 **/